/* eslint-disable */
import React, { useState } from "react";
import BossDialog from "../../components/BossDialog";
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE } from "../../framework/constant/constant";
import { EditPageHeader } from "../../components/EditPageHeader";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";

const TranscodeDefinitionEditForm = (props) => {

    const lang = useTranslation();
    const blankDataItem = {
        ...props?.item,
        SID: props?.item?.SID ?? 0,
        Description: props?.item?.copy ? 'copy of ' + props?.item?.Description : props?.item?.Description ?? '',
        Archive: props?.item?.Archive ?? false,
    }

    const [dataItem, setDataItem] = useState(blankDataItem);

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    //function to check the validation in form
    const isValid = () => {
        if (!dataItem.Description || dataItem.Description == "") {
            toast.error(`${lang.please_enter_destination_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }

        return true;
    }

    const handleSubmit = async (e) => {

        if (!isValid()) return;
        const saveData = {
            _id: dataItem?._id,
            SID: dataItem?.SID ?? 0,
            Description: dataItem?.Description,
            Archive: dataItem?.Archive ?? false,
            checkDuplicate: true,
            query: [["Description", "=", dataItem.Description]]
        }
        console.log(saveData);

        let res = await API.saveData(ENTITYNAME.TranscodeDefinition, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.TRANSCODE_DEFINITION, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.TranscodeDefinition);
            props.cancelEdit();
            props.refresh();
        }
        else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    return (
        <BossDialog
            title={props.item.SID > 0 ? props.item.Description : lang.transcode_definition_header}
            onClose={props.cancelEdit}
            width={"460px"}
        >
            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
            <div className="row mt-2 form-group">
                <div className="col-9">
                    <label>{lang.description_label} *</label>
                    <input
                        name="Description"
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.Description}
                    />
                </div>
                 <div className="col-3" style={{marginTop: "25px"}} >
                    <input
                        type="checkbox"
                        name="Archive"
                        onChange={onChange}
                        value={dataItem.Archive}
                        checked={dataItem.Archive} />
                    <label className="ml-1">{lang.archive}</label>
                </div>
            </div>
        </BossDialog>)

}

export default TranscodeDefinitionEditForm

